import Vue from 'vue'
import Vuex from 'vuex'

import manageRoles from "./manageRoles";
import notificationEmails from "./notificationEmails";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    manageRoles,
    notificationEmails
  }
})
